import React, { useEffect } from "react";
import AOS from "aos";

// Material UI Components
import { Box, Typography, Grid } from "@mui/material";

// Material UI Icons
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";

export default function RulesAndFAQs() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <Box
      data-aos="fade-up"
      sx={{
        padding: { xs: "16px", sm: "32px", md: "48px" },
        bgcolor: "#023047",
        color: "white",
        minHeight: "100vh",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.8rem", md: "2.5rem", lg: "3rem" },
          textAlign: "center",
          fontWeight: "bold",
          mb: { xs: 0, sm: 2, md: 3, lg: 3, xl: 3 },
          color: "white",
        }}
      >
        🌟 WoC 7.0 - Rules and FAQs 🌟
      </Typography>

      <Box
        sx={{
          bgcolor: "white",
          borderRadius: "10px",
          color: "black",
          my: { xs: 3, sm: 4, md: 6, lg: 8, xl: 10 },
          p: 4,
        }}
      >
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> 📘 There are{" "}
              <span style={{ fontWeight: "bold", color: "#023e8a" }}>
                no prerequisites
              </span>{" "}
              for applying to this program. If you need supplementary material
              or resources for a topic or programming language, you'll be
              supplied with them.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon />⏰ The deadline for registration is{" "}
              <span style={{ fontWeight: "bold", color: "red" }}>
                11:59 PM, 2nd January 2025,
              </span>{" "}
              after which no registrations will be accepted.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12}>
            <Typography
              variant="body1"
              fontWeight="bold"
              paragraph
              sx={{ lineHeight: 1.6 }}
            >
              <PlayArrowRoundedIcon /> 🎓 B. Tech first-year projects are
              exclusively for first-year students. Only they are allowed to opt
              for those projects.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> 📚 This is a self-learning program. You
              will be provided with resources and guided by a mentor. They will
              solve your doubts and help you stay on track.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> 🛤️ Each project comes with a roadmap, but
              the learning is self-paced. The workload depends on the
              individual.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> 👩‍💻 You will be assigned only one project.
              We believe that focusing on one project ensures better outcomes.
              If you're interested in additional projects, you can contact your
              mentor for approval.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> 🚀 If you already know everything about
              the project and complete it without learning anything new, we
              might not consider you for the competition. The main aim of this
              program is learning. If you're experienced with a tech stack, we
              encourage you to try a new one!
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> 💡 If you are unable to complete the
              project, don't worry! We'll be glad you learned something and will
              assist you as needed.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              <PlayArrowRoundedIcon /> 🏆 Projects will be evaluated based on
              their functionality, creativity, and completion of the assigned
              roadmap.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
